import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { ParkingContract } from '../../model/parking-contract';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ContractService } from './../base/contract';
import { Contract } from '../../model/contract';
import { Observable } from 'rxjs';

@Injectable()
export class ParkingContractService extends ContractService<ParkingContract> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ParkingContract, progressBar, 'parking-agreement', 'Bilplatskontrakt.xlsx');
  }

  retrieveUpdatedLeaseAgreementParking(contract: Contract): Observable<any> {
    return this.client.patch(`${this.endpoint}/get-updated-parking`, contract);
  }
}
